import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import IntlMessage from 'components/util-components/IntlMessage';
import { NavItem } from '../../layouts/app-layout/NavItem';
import PageHeader, { BreadcrumbItem } from './PageHeader';

interface AppBreadcrumbProps {
  routeInfo: NavItem;
  navItems: NavItem[];
}

const AppBreadcrumb = ({ routeInfo, navItems }: AppBreadcrumbProps) => {
  const breadcrumbData = useMemo(() => {
    const breadcrumbData: Record<string, any> = {};
    navItems.forEach((elm, i) => {
      const assignBreadcrumb = (obj: NavItem) => (breadcrumbData[obj.path] = <IntlMessage id={obj.title} />);
      assignBreadcrumb(elm);
      if (elm.submenu) {
        elm.submenu.forEach((elm) => {
          assignBreadcrumb(elm);
          if (elm.submenu) {
            elm.submenu.forEach((elm) => {
              assignBreadcrumb(elm);
            });
          }
        });
      }
    });
    return breadcrumbData;
  }, [navItems]);
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  const breadcrumbs: BreadcrumbItem[] = pathSnippets
    .map((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
      const label = breadcrumbData[url];
      if (!label) {
        return null;
      }
      return {
        name: label,
        link: url,
      };
    })
    .filter((it) => it)
    .map((it) => it!);
  return <PageHeader display={routeInfo?.breadcrumb} breadcrumbs={breadcrumbs} />;
};

export default AppBreadcrumb;
